import { create } from 'zustand';
import { devtools, persist } from 'zustand/middleware';
import { createSurveySlice } from './store/surveySlice.js';
import { createQuestionsSlice } from './store/questionsSlice.js';
import { createOptionsSlice } from './store/optionsSlice.js';
import { createDataSlice } from './store/dataSlice.js';
import { createUISlice } from './store/uiSlice.js';
import { defaultSurvey, defaultQuestions } from './store/surveyStoreDefaults.js';
import {QUESTION_TYPES, TEXT_INPUT_SUBTYPES} from "./store/types.js";

export { QUESTION_TYPES, TEXT_INPUT_SUBTYPES}
export const useSurveyStore = create(
    persist(
        devtools(
            (set, get) => ({
              // Base defaults
              survey: { ...defaultSurvey },
              questions: [...defaultQuestions],
              selectedQuestionId: null,
              isPreviewMode: false,
              isDirty: false,
              isLoading: false,
              error: null,

              // Combine slices
              ...createSurveySlice(set, get),
              ...createQuestionsSlice(set, get),
              ...createOptionsSlice(set, get),
              ...createDataSlice(set, get),
              ...createUISlice(set, get),

              // Reset store
              resetStore: () => {
                set({
                  survey: { ...defaultSurvey },
                  questions: [...defaultQuestions],
                  selectedQuestionId: null,
                  isPreviewMode: false,
                  isDirty: false,
                  isLoading: false,
                  error: null,
                });
              },

              logCurrentState: () => {
                const state = get();
                console.log('Survey Store State:', state);
                return state;
              },
            }),
            { name: 'survey-store-devtools' }
        ),
        {
          name: 'survey-store', // key in localStorage
          getStorage: () => localStorage,
        }
    )
);
